// src/components/layout/SuperSidebar.jsx
import React from "react";
import AdminPortalSidebar from "./AdminPortalSidebar";

const SuperSidebar = ({ isOpen, onClose }) => (
  <AdminPortalSidebar
    isOpen={isOpen}
    onClose={onClose}
    basePath="/superadmin"
    dashboardPath="/superdashboard"
    portalLabel="SUPER ADMIN PORTAL"
  />
);

export default SuperSidebar;
